module.exports = __webpack_public_path__ + "static/img/third8.053d2ea9.png";